import { mapGetters } from 'vuex'
import help from '@/utils/help'
import zip from '@/utils/zip'
import { editorDecision, editorFinal, editor } from '@/api/editor'
import { settingOption } from '@/api/setting'
import { AUTHOR_REVISION, DECISION, DECISION_STATUS } from '@/utils/dict'
import { getUploadConfig } from '@/utils/upload'
import SendEmail from '../../../manuscripts/dialog/send-email.dialog'
import customerReviewQuestion from '@/components/question.vue'

export default {
  components: { SendEmail, customerReviewQuestion },
  data() {
    return {
      // 取回数据
      reviewsResponse: [],
      showVersion1: false,
      showDecision1: false,
      showReviewer1: false,
      showReport1: false,
      // 填写数据
      reviews: {
        reason: '',
        reasonId: ''
      },

      showSendEmail: false,
      inputData: {},
      event: '',
      files: [],
      //
      rules: {},
      reviewerFileList: [],
      isMoreText: false,
      DECISION,
      AUTHOR_REVISION,
      // termList: { DECISION, AUTHOR_REVISION },
      termListStatus: DECISION_STATUS,
      reviewerTogal: {},
      routeStatu: '',
      statu: 1,
      parmas: {},
      loading: false,
      submitStatu: '',
      refuseList: [], // 拒绝理由列表
      selectReason: '', //
      isOpenItem: [], //控制每级面板的打开与折叠
      isSelectAll: [], //控制每级面板的选中状态
      othersReason: '',
      othersId: []
    }
  },

  async mounted() {
    this.routeStatu = this.$route.name
    await this.getRefuseList()
    this.initData()
    this.getData()
    this.getRules()
    help.closeAutocomplete()
  },
  computed: {
    ...mapGetters({
      language: 'getLanguage',
      publisherId: 'getPublisherId',
      manuscriptType: 'getManuscriptType',
      country: 'getCountry',
      title: 'getTitle',
      user: 'getUser',
      domain: 'getDomain'
    })
  },
  watch: {
    // isMoreText:
  },
  methods: {
    getRules() {
      this.rules = {
        reviseDueTime: [
          {
            required: true,
            message: this.LANGUAGE[this.language].noEmpty
          }
        ]
      }
    },

    // 获取数据
    async getData() {
      let routeStatu = this.$route.name
      let { sign, manuscriptId } = this.$route.query
      let data = {
        sign,
        manuscriptId
      }
      let result = []
      switch (routeStatu) {
        case '/editorial-office/manuscripts/author-revision':
          this.statu = 0
          break
        case '/editorial-office/manuscripts/decisions-final':
          this.statu = 1
          break
        case '/editorial-office/manuscripts/decisions-editorial':
          this.statu = 2
          break
        default:
          this.statu = 0
      }
      // console.log(this.statu, 'statu')
      if (this.statu === 2) {
        result = await editorDecision.get(data)
      } else {
        result = await editorFinal.decision(data)
      }
      this.reviewsResponse = result
      this.reviews = result.meditor || {}
      this.reviews = Object.assign(this.reviews, {
        forReviewerFileList: result.forReviewerFileList
      })
      this.reviews &&
        this.reviews.forReviewerFileList &&
        this.reviews.forReviewerFileList.map(item => {
          item.authorShowed =
            item.authorShowed == undefined ? true : item.authorShowed
          return item
        })
      // console.log(this.reviews.forReviewerFileList, 'file')
      if (this.statu === 0) {
        this.reviews.decisionStatus = ''
      }
      this.reviewerFileList =
        result.meditor && result.meditor.meditorFileList
          ? result.meditor.meditorFileList
          : []

      this.othersReason = this.reviews.reason
      this.selectReason = this.reviews.reasonId
      this.refuseList.map((item, root) => {
        if (item.children) {
          item.children.map((child, leaf) => {
            if (child.id == this.selectReason) {
              this.$set(child, 'checked', true)
              this.$forceUpdate()
              if (child.name === 'Others') {
                this.$set(child, 'check', true)
                this.$forceUpdate()
              }
              this.$set(item, 'checked', true)
              this.$forceUpdate()
              this.$set(this.isOpenItem[root], 'group', true)
              this.$set(this.isSelectAll[leaf], 'group', true)
              this.$forceUpdate()
            }
          })
        }
      })
    },

    onChange() {},

    // 文件修改
    async handleUpload(files) {
      const types = [
        'pdf',
        'docx',
        'doc',
        'txt',
        'png',
        'jpg',
        'jpeg',
        'mp4',
        'mp3',
        'html',
        'xml',
        'mov',
        'xls',
        'xlsx',
        'zip',
        'tif',
        'tiff',
        'rtf'
      ]
      if (files.length === 1) {
        const file = files[0]
        let type = file.name.split('.')
        type = type[type.length - 1].toLowerCase()
        if (!types.includes(type)) {
          this.$message.error({
            title: 'Error',
            content: this.LANGUAGE[this.language].isWrongType
          })
          return false
        } else {
          this.addFile(file)
        }
      } else {
        files.forEach(file => {
          let type = file.name.split('.')
          type = type[type.length - 1].toLowerCase()
          if (types.includes(type)) {
            this.addFile(file)
          }
        })
      }

      // const MS = 200
      // const maxSize = file.size / 1024 / 1024 < MS
      // if (!maxSize) {
      //   this.$message.error({
      //     title: 'Error',
      //     content: this.LANGUAGE[this.language].notExceed + MS + 'MB'
      //   })
      //   return false
      // }
    },
    async addFile(file) {
      const path = `publisher/${this.publisherId}/manuscript/${
        this.$route.query.manuscriptId
      }/submit/${help.guid()}`

      this.loading = true
      const url = await getUploadConfig(file, path)
      if (url.includes('err:')) {
        this.$message.error({
          title: 'Error',
          content: this.LANGUAGE[this.language].uploadFileFail
        })
        return false
      }
      const flag = this.reviewerFileList.some(val => {
        if (file.name === val.name) {
          val = {
            name: file.name,
            size: file.size,
            description: '',
            path: url,
            file: file,
            authorShowed: val.authorShowed ? val.authorShowed : true,
            sort: val.sort
          }
          return true
        }
      })
      if (!flag) {
        this.reviewerFileList.push({
          name: file.name,
          size: file.size,
          path: url,
          file: file,
          authorShowed: true,
          sort: ''
        })
      }
      this.loading = false
      this.reviewerFileList.forEach((item, index) => {
        item.sort = index
      })
    },
    // 文件上传
    async handleUpload1(files, itemrep, i, key) {
      const types = [
        'pdf',
        'docx',
        'doc',
        'txt',
        'png',
        'jpg',
        'jpeg',
        'mp4',
        'mp3',
        'html',
        'xml',
        'mov',
        'xls',
        'xlsx',
        'zip',
        'tif',
        'tiff',
        'rtf'
      ]
      if (files.length === 1) {
        const file = files[0]
        let type = file.name.split('.')
        type = type[type.length - 1].toLowerCase()
        if (!types.includes(type)) {
          this.$message.error({
            title: 'Error',
            content: this.LANGUAGE[this.language].isWrongType
          })
          return false
        } else {
          this.addFile1(file, itemrep, key)
        }
      } else {
        files.forEach(file => {
          let type = file.name.split('.')
          type = type[type.length - 1].toLowerCase()
          if (types.includes(type)) {
            this.addFile1(file, itemrep)
          }
        })
      }
    },
    async addFile1(file, itemrep, key) {
      const path = `publisher/${this.publisherId}/manuscript/${
        this.$route.query.manuscriptId
      }/submit/${help.guid()}`

      this.uploadProgress = {
        current: 0,
        total: this.reviewerFileList.length
      }
      const pro_all = []
      this.loading = true
      // console.log(itemrep, key, itemrep[key])

      itemrep[key] = itemrep[key] ? itemrep[key] : []
      const flag =
        itemrep[key] &&
        itemrep[key].some(val => {
          if (file.name === val.name) {
            val = {
              id: '',
              name: file.name,
              size: file.size,
              description: '',
              path: '',
              file: file,
              authorShowed: val.authorShowed,
              sort: val.sort,
              reviewerSelf: val.reviewerSelf || false
            }
            return true
          }
        })
      if (!flag) {
        itemrep[key].push({
          id: '',
          name: file.name,
          size: file.size,
          description: '',
          path: '',
          file: file,
          authorShowed: true,
          sort: '',
          reviewerSelf: true
        })
      }
      itemrep[key].map((ele, i) => {
        ele.sort = ele.sort ? ele.sort : i
        ele.authorShowed =
          ele.authorShowed == undefined ? true : ele.authorShowed
        if (!ele.path) {
          pro_all[i] = getUploadConfig(ele.file, path)
            .then(res => {
              if (res && !res.includes('err:')) {
                this.uploadProgress.current++
              }
              return res
            })
            .then(res => {
              ele.path = res
              return res
            })
        } else {
          this.uploadProgress.current++
        }
      })
      const reses = await Promise.all(pro_all)
      this.loading = false
      this.errArr = []
      reses.forEach(item => {
        if (item && item.includes('err:')) {
          this.errArr.push(item.split(':')[1])
        }
      })
      if (this.errArr.length) {
        this.$message.error(this.LANGUAGE[this.language].uploadFileFail, 5)
        this.uploadProgress = {
          current: 0,
          total: 0
        }
        return
      }
    },

    // 文件列表
    setSort() {},
    download(item) {
      const file = item
      if (file) {
        const url = file.path
          ? this.domain + '/' + file.path
          : window.URL.createObjectURL(file.file)
        help.download(url, file.name)
      } else {
        zip.zipFile(item, 'author_files.zip')
      }
    },
    del(index) {
      this.$confirm({
        title: 'Are you sure you want to delete this file?',
        content:
          'Please be aware of once this file is deleted, it will never be able to recovered.',
        type: 'danger',
        icon: 'iconDelete'
      }).then(async () => {
        if (index || index === 0) {
          this.reviewerFileList.splice(index, 1)
        } else {
          this.reviewerFileList = []
        }
        this.$message.success({
          title: 'Success',
          content: 'This file has been deleted!'
        })
      })
    },
    del1(item, index, key) {
      this.$confirm({
        title: 'Are you sure you want to delete this file?',
        content:
          'Please be aware of once this file is deleted, it will never be able to recovered.',
        type: 'danger',
        icon: 'iconDelete'
      }).then(async () => {
        if (index || index === 0) {
          item[key].splice(index, 1)
        } else {
          item[key] = []
        }
        this.$message.success({
          title: 'Success',
          content: 'This file has been deleted!'
        })
      })
    },

    // 保存
    async commit(statu) {
      if (
        this.reviews.decisionStatus === 'REJECTED' &&
        this.othersReason &&
        this.othersReason.length > 2048
      ) {
        this.$message.error({
          title: 'Error',
          content: `The length of reason is too long and must be less than 2048 bytes.`
        })
        return
      }
      // let flag = this.$refs['reviews-commit'].validate()
      if (!this.reviews.decisionStatus) {
        this.$message.error({
          title: 'Error',
          content: 'Please select a decision status!'
        })
        return
      }

      if (this.reviews.decisionStatus === 'REJECTED' && !this.selectReason) {
        this.$message.error({
          title: 'Error',
          content: `Reject Reason can't be empty!`
        })
        return
      }

      if (
        this.reviews.decisionStatus === 'REJECTED' &&
        this.selectReason &&
        !this.othersReason.trim()
      ) {
        const flag = this.othersId.find(id => {
          return id === this.selectReason
        })
        if (flag) {
          this.$message.error({
            title: 'Error',
            content: `Reject Reason can't be empty!`
          })
          return false
        }
      }

      if (
        this.reviews.decisionStatus === 'PAPER_ACCEPTED' ||
        this.reviews.decisionStatus === 'REJECTED' ||
        this.reviews.decisionStatus === 'WITHDRAWN'
      ) {
        this.reviews.reviseDueTime = null
      } else {
        if (!this.reviews.reviseDueTime) {
          this.$message.error({
            title: 'Error',
            content: 'Please select a Revision Due Date!'
          })
          return
        }
        if (
          this.reviews.reviseDueTime &&
          this.$moment(this.reviews.reviseDueTime).diff(this.$moment()) < 0
        ) {
          this.$message.error({
            title: 'Error',
            content: 'Please select a right Revision Due Date!'
          })
          return
        }
      }

      if (this.reviews.decisionStatus !== 'REJECTED') {
        this.othersReason = null
        this.selectReason = null
      }

      let {
        decisionStatus,
        reviseDueTime,
        authorNotes,
        editorNotes,
        forReviewerFileList
      } = this.reviews
      this.parmas.meditor = {
        decisionStatus,
        reviseDueTime,
        authorNotes,
        editorNotes,
        reason: this.othersReason,
        reasonId: this.selectReason
      }
      this.parmas.id = this.$route.query.manuscriptId
      this.parmas.sign = this.reviewsResponse.sign
      this.parmas.meditor.meditorFileList = this.reviewerFileList
      this.parmas.editorReviewerList = this.reviewsResponse.reviewerList
      this.parmas.forReviewerFileList = forReviewerFileList

      // 作者部分是否显示文件过滤（去除）

      // let desionArr1 = JSON.parse(
      //   JSON.stringify(this.reviewsResponse.reviewerList)
      // )
      // if (statu == 'author') {
      //   for (let i = 0; i < desionArr1.length; i++) {
      //     for (let j = 0; j < desionArr1[i].reviewerDecisionList.length; j++) {
      //       let ele = desionArr1[i].reviewerDecisionList[j]
      //       ele.reviewerFileList &&
      //         ele.reviewerFileList.map((itemfile, indexfile) => {
      //           if (!itemfile.authorShowed) {
      //             ele.reviewerFileList.splice(indexfile, 1)
      //           }
      //         })
      //     }
      //   }
      //   this.parmas.editorReviewerList = desionArr1
      //   this.parmas.meditor.meditorFileList = this.reviewerFileList.filter(
      //     item => item.authorShowed === true
      //   )
      // }
      // console.log(this.parmas, 'this.parmas.editorReviewerList')

      if (statu === 'author' || statu === 'final') {
        this.sendEmail(statu)
      } else {
        await editorDecision[statu](this.parmas)
        this.$router.push(
          `/editorial-office/manuscripts/details/${this.parmas.id}`
        )
      }
    },

    cancel() {
      this.showSendEmail = false
      this.$router.back(-1)
    },

    // 审稿人展开
    togalReviewer(item) {
      item.showReviewer == undefined
        ? (item.showReviewer = true)
        : (item.showReviewer = !item.showReviewer)
      this.reviewsResponse.reviewerList = JSON.parse(
        JSON.stringify(this.reviewsResponse.reviewerList)
      )
    },
    togalReport(item, type) {
      // item.showReport == undefined
      //   ? (item.showReport = true)
      //   : (item.showReport = !item.showReport)
      item[type] == undefined ? (item[type] = true) : (item[type] = !item[type])
      this.reviewsResponse.reviewerList = JSON.parse(
        JSON.stringify(this.reviewsResponse.reviewerList)
      )
    },
    authorStatus(itemfile) {
      itemfile.authorShowed == undefined
        ? (itemfile.authorShowed = true)
        : (itemfile.authorShowed = !itemfile.authorShowed)
    },
    reviewAuthor(item) {
      item.authorShowed == undefined
        ? (item.authorShowed = true)
        : (item.authorShowed = !item.authorShowed)
    },

    changeDate(val) {
      if (val < this.$moment()) {
        this.$message.error({
          title: 'Error',
          content: 'Please select a right Revision Due Date!'
        })
        return
      }
    },

    async send() {
      // await editorDecision.author(this.parmas)
      await editorDecision[this.submitStatu](this.parmas)
      this.showSendEmail = false
      this.$router.push(
        `/editorial-office/manuscripts/details/${this.parmas.id}`
      )
    },

    // 发送邮件
    sendEmail(statu) {
      this.submitStatu = statu
      const { id, submitter, meditor, journalId, sign } = this.reviewsResponse
      const codes = {
        PAPER_ACCEPTED: 'ACCEPT_MANUSCRIPT',
        PENDING_MINOR_REVISIONS: 'MINOR_REVISION_FOR_MANUSCRIPT',
        PENDING_MAJOR_REVISIONS: 'MAJOR_REVISION_FOR_MANUSCRIPT',
        REJECTED: 'REJECT_MANUSCRIPT',
        WITHDRAWN: 'WITHDRAW'
      }
      if (statu === 'author') {
        this.event = codes[this.reviews.decisionStatus]
        this.inputData = {
          manuscriptId: id,
          sign,
          journalId,
          email: submitter && submitter.email,
          editorId: meditor && meditor.id,
          authorPersonId: submitter && submitter.id,
          editorPersonId: this.user && this.user.personId,
          reviseDueTime: this.reviews.reviseDueTime
        }
        this.files = this.reviewerFileList.filter(item => {
          return item.authorShowed
        })
      } else if (statu === 'final') {
        this.event = 'AE_SEND_TO_ME_FOR_DECISION'
        this.inputData = {
          manuscriptId: id,
          sign,
          journalId
        }
      }

      // console.log(this.files, '文件', this.reviewerFileList)
      this.showSendEmail = true
    },

    //拒绝理由列表
    async getRefuseList() {
      const params = {
        publisherId: this.publisherId,
        personId: ''
      }
      this.refuseList = await editor.refuse(params)
      this.initSetCheck()
      this.getOthersIds(this.refuseList)
    },

    // 处理Others
    getOthersIds(list) {
      const ids = []
      list &&
        list.map(item => {
          if (item.children) {
            item.children.map(child => {
              if (child.name === 'Others') {
                ids.push(child.id)
              }
            })
          }
        })
      this.othersId = ids
    },
    // 添加check属性
    initSetCheck() {
      this.refuseList.map(item => {
        if (item.children) {
          item.children.map(child => {
            Object.assign(child, {
              check: false
            })
          })
        }
      })
    },
    checkItem(index) {
      //展开或折叠面板
      this.othersReason = ''
      this.refuseList.map((item, root) => {
        if (item.children) {
          item.children.map((child, leaf) => {
            this.$set(child, 'check', false) // others
            this.$forceUpdate()
            this.$set(child, 'checked', false) // 节点选中
            this.$forceUpdate()
            this.$set(this.isOpenItem[root], 'group', false)
          })
        }
      })
      this.$set(this.isOpenItem[index], 'group', !this.isOpenItem[index].group)
    },

    stateChanged(item, index, i) {
      this.othersReason = ''
      this.selectReason = item.id
      if (item.name === 'Others') {
        this.refuseList.map(node => {
          if (node.children) {
            node.children.map(child => {
              this.$set(child, 'check', false)
              this.$forceUpdate()
            })
          }
        })
        this.$set(item, 'check', true)
        this.$forceUpdate()
      } else {
        this.refuseList.map(node => {
          if (node.children) {
            node.children.map(child => {
              this.$set(child, 'check', false)
              this.$forceUpdate()
            })
          }
        })
      }
      this.refuseList.map((item, root) => {
        this.$set(item, 'checked', false)
        if (item.children) {
          item.children.map((child, leaf) => {
            if (child.id == this.selectReason) {
              this.$set(child, 'checked', true)
              this.$forceUpdate()
              this.$set(item, 'checked', true)
              this.$forceUpdate()
              this.$set(this.isOpenItem[root], 'group', true)
              this.$set(this.isSelectAll[leaf], 'group', true)
              this.$forceUpdate()
            }
          })
        }
      })
    },

    initData() {
      //数据初始化
      let len = this.refuseList.length
      for (let i = 0; i < len; i++) {
        //根据数据初始化全选按钮状态
        this.isSelectAll.push([])
        // Object.assign(this.isSelectAll[i], { group: false })
        this.$set(this.isSelectAll[i], 'group', false)
        this.$set(this.isSelectAll[i], 'child', [])
        //根据数据初始化折叠面板折叠状态
        this.isOpenItem.push([])
        this.$set(this.isOpenItem[i], 'group', false)
        this.$set(this.isOpenItem[i], 'child', [])
        //设置第二层级的状态
        for (let j in this.refuseList[i].children) {
          this.isSelectAll[i].child.push(false)
          this.isOpenItem[i].child.push(false)
        }
      }
    }
  }
}
